import { useContext } from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Link from '../components/Link.tsx'
import { AppContext } from '../state/Context.tsx'

const useStyles = makeStyles((theme) => ({
	root: {
		color: 'ivory',
		textAlign: 'center',
		paddingTop: '3.5em',
		paddingBottom: '2em',
	},
	heading: {
		fontFamily: 'ZhiMangXing, Roboto',
	},
	subtitle: {
		padding: '0 2em',
	},
}))

function Header() {
	const { root, heading, subtitle } = useStyles()

	const { dispatch } = useContext(AppContext)

	function clearQuery() {
		return dispatch({
			pendingSearchQuery: '',
			searchQuery: '',
			results: null,
			resultsLoading: false,
		})
	}

	return (
		<header className={root}>
			{/* @ts-ignore TODO: types */}
			<Typography variant='h1' component='h1' className={heading}>
				<Link
					tabIndex={-1}
					to='/'
					onClick={clearQuery}
					className='unstyled'
				>
					字字不忘
				</Link>
			</Typography>
			{/* @ts-ignore TODO: types */}
			<Typography
				className={subtitle}
				variant='subtitle2'
				component='div'
			>
				Zi Zi Bu Wang · Chinese Dictionary Lookup
			</Typography>
		</header>
	)
}

export default Header
